import { useEffect, useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import { api } from "../../lib/api";

export default function AdminAnalyticsDashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api("/api/admin/analytics/overview")
      .then(setData)
      .catch((err) => setError(err.message));
  }, []);

  return (
    <AdminLayout title="Website Analytics" subtitle="Track page views, popular content, recent visits and 30-day traffic trends.">
      {error && <div className="mb-4 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}
      {!data ? <div className="rounded-3xl bg-white p-8 shadow-sm">Loading analytics...</div> : (
        <div className="space-y-8">
          <div className="grid gap-4 md:grid-cols-3">
            <div className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200"><p className="text-sm font-bold uppercase text-slate-500">Total views</p><p className="mt-3 text-4xl font-black">{data.total_views}</p></div>
            <div className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200"><p className="text-sm font-bold uppercase text-slate-500">Unique sessions</p><p className="mt-3 text-4xl font-black">{data.unique_sessions}</p></div>
            <div className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200"><p className="text-sm font-bold uppercase text-slate-500">Today</p><p className="mt-3 text-4xl font-black">{data.today_views}</p></div>
          </div>

          <section className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
            <h2 className="text-xl font-black">Top pages</h2>
            <div className="mt-4 overflow-x-auto">
              <table className="w-full text-sm"><thead className="text-left text-xs uppercase text-slate-500"><tr><th className="p-3">Page</th><th className="p-3">Views</th><th className="p-3">Sessions</th></tr></thead><tbody>{(data.top_pages || []).map((row) => <tr key={row.page_path} className="border-t"><td className="p-3 font-bold text-emerald-700">{row.page_path}</td><td className="p-3">{row.views}</td><td className="p-3">{row.sessions}</td></tr>)}</tbody></table>
            </div>
          </section>

          <section className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
            <h2 className="text-xl font-black">Last 30 days</h2>
            <div className="mt-4 grid gap-2 md:grid-cols-5">
              {(data.daily || []).map((row) => <div key={row.view_date} className="rounded-2xl bg-slate-50 p-4"><p className="text-xs font-bold text-slate-500">{String(row.view_date).slice(0,10)}</p><p className="mt-1 text-2xl font-black">{row.views}</p></div>)}
            </div>
          </section>

          <section className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
            <h2 className="text-xl font-black">Recent views</h2>
            <div className="mt-4 space-y-2">{(data.recent_views || []).map((row, index) => <div key={index} className="rounded-2xl border p-4"><p className="font-bold">{row.page_path}</p><p className="text-xs text-slate-500">{row.created_at} {row.referrer ? `• from ${row.referrer}` : ""}</p></div>)}</div>
          </section>
        </div>
      )}
    </AdminLayout>
  );
}
